import { render, staticRenderFns } from "./Ignite.vue?vue&type=template&id=89a12496&scoped=true"
import script from "./Ignite.vue?vue&type=script&lang=js"
export * from "./Ignite.vue?vue&type=script&lang=js"
import style0 from "./Ignite.vue?vue&type=style&index=0&id=89a12496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a12496",
  null
  
)

export default component.exports